// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"0beba046","97":"7a36d6ab","453":"6b11d6c5","472":"69d7420c","972":"fd7da6f2"}[chunkId] + ".chunk.js";
};